import { lazyNamed } from 'src/utils/lazyNamed.ts';

export default {
  WebsiteGroupsList: lazyNamed(() => import('./containers/WebsiteGroupsList/index.tsx'), 'WebsiteGroupsList'),
  WebsiteGroupForm: lazyNamed(() => import('./containers/WebsiteGroupForm/index.tsx'), 'WebsiteGroupForm'),
};
